/* eslint-disable */

// THIS IS A FORK !!!
// https://github.com/browserify/vm-browserify/blob/master/index.js

// added the following code to fix inconsistency between chrome and firefox (when a promise is returned as a result from the vm)
// where killing the iframe in firefox results in freezing the returned promise (if it was pending then it will stay pending forever)
// the fix is to create a new promise, wait on the old promise to settle and then run the cleanup logic

/*
  if (({}).toString.call(res) === '[object Promise]') {
    return new Promise((next, error) => {
      res.catch(error).then(next);
    })
      .finally(() => document.body.removeChild(iframe));
  }
*/


const indexOf = function (xs, item) {
  if (xs.indexOf) return xs.indexOf(item);
  for (let i = 0; i < xs.length; i++) {
    if (xs[i] === item) return i;
  }
  return -1;
};
const Object_keys = function (obj) {
  if (Object.keys) return Object.keys(obj);

  const res = [];
  for (const key in obj) res.push(key);
  return res;
};

const forEach = function (xs, fn) {
  if (xs.forEach) return xs.forEach(fn);
  for (let i = 0; i < xs.length; i++) {
    fn(xs[i], i, xs);
  }
};

const defineProp = (function () {
  try {
    Object.defineProperty({}, '_', {});
    return function (obj, name, value) {
      Object.defineProperty(obj, name, {
        writable: true,
        enumerable: false,
        configurable: true,
        value,
      });
    };
  } catch (e) {
    return function (obj, name, value) {
      obj[name] = value;
    };
  }
}());

const globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
  'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
  'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
  'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
  'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript(code) {
  if (!(this instanceof Script)) return new Script(code);
  this.code = code;
};

Script.prototype.runInContext = function (context) {
  if (!(context instanceof Context)) {
    throw new TypeError("needs a 'context' argument.");
  }

  const iframe = document.createElement('iframe');
  if (!iframe.style) iframe.style = {};
  iframe.style.display = 'none';

  document.body.appendChild(iframe);

  const win = iframe.contentWindow;
  let wEval = win.eval; const
    wExecScript = win.execScript;

  if (!wEval && wExecScript) {
    // win.eval() magically appears when this is called in IE:
    wExecScript.call(win, 'null');
    wEval = win.eval;
  }

  forEach(Object_keys(context), (key) => {
    win[key] = context[key];
  });
  forEach(globals, (key) => {
    if (context[key]) {
      win[key] = context[key];
    }
  });

  const winKeys = Object_keys(win);

  const res = wEval.call(win, this.code);

  forEach(Object_keys(win), (key) => {
    // Avoid copying circular objects like `top` and `window` by only
    // updating existing context properties or new properties in the `win`
    // that was only introduced after the eval.
    if (key in context || indexOf(winKeys, key) === -1) {
      context[key] = win[key];
    }
  });

  forEach(globals, (key) => {
    if (!(key in context)) {
      defineProp(context, key, win[key]);
    }
  });

  if (({}).toString.call(res) === '[object Promise]') {
    return new Promise((next, error) => {
      res.catch(error).then(next);
    })
      .finally(() => document.body.removeChild(iframe));
  }

  document.body.removeChild(iframe);
  return res;
};

Script.prototype.runInThisContext = function () {
  return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
  const ctx = Script.createContext(context);
  const res = this.runInContext(ctx);

  if (context) {
    forEach(Object_keys(ctx), (key) => {
      context[key] = ctx[key];
    });
  }

  return res;
};

forEach(Object_keys(Script.prototype), (name) => {
  exports[name] = Script[name] = function (code) {
    const s = Script(code);
    return s[name].apply(s, [].slice.call(arguments, 1));
  };
});

exports.isContext = function (context) {
  return context instanceof Context;
};

exports.createScript = function (code) {
  return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
  const copy = new Context();
  if (typeof context === 'object') {
    forEach(Object_keys(context), (key) => {
      copy[key] = context[key];
    });
  }
  return copy;
};
